import background1 from "../../media/backgrounds/background1.png";
import background2 from "../../media/backgrounds/background2.png";
import background3 from "../../media/backgrounds/background3.png";
import background4 from "../../media/backgrounds/background4.png";
import background5 from "../../media/backgrounds/background5.png";
import { useCurrentGroupStore } from "../../stores/useCurrentGroupStore";
import { _setGroupBackground } from "../../data/groups";

function GroupEditBackground({ groupId }) {
    const _updateCachedBackground = useCurrentGroupStore((state) => state.setGroupBackground);

    const backgroundList = {
        background1: background1,
        background2: background2,
        background3: background3,
        background4: background4,
        background5: background5
    };

    const setGroupBackground = async (background) => {
        await _setGroupBackground(groupId, background);
        await _updateCachedBackground(background);
    }

    return (
        <>
            <div className="mr-auto ml-auto has-text-weight-semibold is-size-5">
                Change Background
            </div>
            <div>
                Select a new background image for your group from the ones below.
            </div>
            <div className="fixed-grid">

                <div className="grid">
                    {Object.keys(backgroundList).sort().map((background, index) => {
                        return (
                            <div className="cell" key={index}>
                                <figure className="image has-text-centered ml-auto mr-auto p-1 " onClick={() => { setGroupBackground(background) }}>
                                    <img src={backgroundList[background]} alt={"Group Background " + index} />
                                </figure>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    );
}

export default GroupEditBackground;